import React from 'react';
import './GdprCheckbox.css';

const GdprCheckbox = ({ gdprChecked, setGdprChecked }) => {
    return (
        <div className="gdpr-container">
            <label className="gdpr-label" htmlFor="gdpr">
                <input 
                    type="checkbox" 
                    id="gdpr" 
                    className="gdpr-checkbox-input"
                    checked={gdprChecked} 
                    onChange={(e) => setGdprChecked(e.target.checked)} 
                />
                <span className="gdpr-text">
                    Elolvastam és elfogadom az{' '}
                    <a href="/adatvedelmi-tajekoztato" target="_blank" rel="noopener noreferrer" className="gdpr-link">
                        Adatvédelmi Tájékoztatót
                    </a>
                </span>
            </label>
        </div>
    );
};

export default GdprCheckbox;